<template>
  <base-form
    v-model="data"
    :options="options"
    labelWidth="100px"
    :disabled="disabled"
    @input="handleChange"
    ref="form"
  ></base-form>
</template>

<script>
  import baseForm from '@/components/form/base-form';
  // import COMPANY_API from '@/api/masterData/company';
  import BASE_API from '@/api/dataBase.js';
  import API from '@/api/masterData/cooperation';
  export default {
    props: {
      defaultData: {
        type: Object,
        default: () => {},
      },
      userInfo: {
        type: Object,
        default: () => {},
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      baseForm,
    },
    data() {
      return {
        data: {},
      };
    },
    computed: {
      options() {
        // const userInfo = this.userInfo;
        // const companyCode = this.data.saleCompanyCode;
        // const departmentUrl = companyCode
        //   ? `${COMPANY_API.GET_COMPANY_DETAIL_API}/${companyCode}`
        //   : '';
        return [
          {
            type: 'ajaxSelect', // 交易类型默认部门间交易
            prop: 'tradeType',
            label: this.$t('departmentBusiness.businessType'),
            apiUrl: API.DICT_LIST,
            apiData: { dictType: 'department_trade_type' },
            required: true,
          },
          {
            type: 'dateYear',
            label: this.$t('departmentBusinessAdd.fisCalYear'),
            prop: 'fiscalYear',
            disabled: true,
            required: true,
          },
          {
            type: 'input',
            label: this.$t('departmentBusinessAdd.sellCompany'),
            prop: 'saleCompanyName',
            disabled: true,
            required: true,
          },
          // {
          //   // 卖出部门搜索
          //   type: 'ajaxSelect',
          //   label: this.$t('departmentBusiness.sellDepartment'),
          //   prop: 'saleDepartmentCode',
          //   apiUrl: departmentUrl,
          //   method: 'get',
          //   dataString: 'data.department',
          //   name: 'saleDepartmentName',
          //   code: 'saleDepartmentCode',
          //   valueKey: 'createDepartmentCode',
          //   labelKey: 'createDepartmentName',
          //   required: true,
          //   valueType: 'object',
          //   disabled: true,
          // },
          {
            type: 'input',
            label: this.$t('departmentBusiness.sellDepartment'),
            prop: 'saleDepartmentName',
            disabled: true,
            required: true,
          },
          {
            type: 'searchTable', // 仓库
            prop: 'saleStorageCode',
            isMultiple: true,
            label: this.$t('departmentBusinessAdd.sellWareHouse'),
            searchType: 'warehouse',
            required: true,
            name: 'saleStorageName',
            code: 'saleStorageCode',
            getName: 'storageName',
            getCode: 'storageCode',
          },
          {
            type: 'input',
            label: this.$t('departmentBusinessAdd.buyCompany'),
            prop: 'buyCompanyName',
            disabled: true,
            required: true,
          },
          {
            // 买入部门
            type: 'ajaxSelect',
            label: this.$t('departmentBusiness.buyDepartment'),
            prop: 'buyDepartmentCode',
            apiUrl: BASE_API.LIST_DEPARTMENT_API + '/' + this.data.buyCompanyCode,
            valueKey: 'value',
            labelKey: 'label',
            name: 'buyDepartmentName',
            code: 'buyDepartmentCode',
            required: true,
            valueType: 'object',
          },
          {
            // 计息日期
            type: 'date',
            label: this.$t('departmentBusiness.interestDate'),
            prop: 'interestDate',
            required: true,
          },
          {
            type: 'textarea',
            label: this.$t('departmentBusinessAdd.remark'),
            prop: 'mark',
            span: 24,
            maxlength: 256,
          },
        ];
      },
    },
    watch: {
      defaultData() {
        this.setData();
      },
    },
    mounted() {
      this.setData();
      // 解决一进页面就错误提示
      this.$refs.form.$refs.ruleForm.resetFields();
    },
    methods: {
      setData() {
        const userInfo = this.userInfo;
        const defaultData = this.defaultData;
        // 填充默认值、查询值
        const data = Object.assign(
          {
            fiscalYear: new Date().getFullYear().toString(),
            saleCompanyCode: userInfo.companyCode,
            saleCompanyName: userInfo.companyName,
            buyCompanyName: userInfo.companyName,
            buyCompanyCode: userInfo.companyCode,
            saleDepartmentCode: userInfo.departmentCode,
            saleDepartmentName: userInfo.departmentName,
          },
          this.data,
          defaultData
        );
        this.data = data;
      },
      handleChange(data, prop) {
        if (this.disabled) return;
        if (prop == 'saleStorageCode') {
          this.$emit('storageChange', data.saleStorageCode, data.saleStorageName);
        }
        if (prop == 'saleDepartmentCode') {
          this.$emit('saleDepartmentChange', data.saleDepartmentCode, data.saleDepartmentName);
        }
      },
      setSaleStorage(saleStorage) {
        this.data = Object.assign({}, this.data, saleStorage);
      },
      // 获取数据
      getValues() {
        const data = this.data;
        const result = Object.assign({}, data, {});
        return result;
      },
      handleSubmit() {
        return this.$refs['form'].handleSubmit();
      },
    },
  };
</script>
